import { useState } from "react";
import Modal from "./modal";
import OvertimeAllowed from "../OvertimeAllowed";

export default (props) => {
  const [showModal, setShowModal] = useState(false);
  const edit = (event) => {
    event.preventDefault();
    setShowModal(!showModal);
  };
  const save = (event) => {
    event.preventDefault();
    props.sumbitJobDetails(false).then((success) => {
      if (success) {
        setShowModal(!showModal);
      }
    });
  };
  return (
    <div className="card  h-100">
      {showModal && (
        <Modal label={"Overtime Allowed"} showHide={edit} saveFunction={save}>
          <OvertimeAllowed errors={props.errors}  />
        </Modal>
      )}
      <div className="card-header">
        <b>
          <h5 className="mb-0">Overtime Allowed</h5>
        </b>
        {props.editMode && (
          <a
            className="edit-icon"
            id="btnShowModel_Job_Type"
            href="#"
            onClick={edit}
          >
            <i className="fe fe-edit" title="Edit Template"></i>
          </a>
        )}
      </div>
      <div className="card-body  d-flex align-items-center">
        <div className="form-group">
        <div className="col-lg-4 col-md-4">
              <label htmlFor="isOvertimeAllowed">
                {props?.isOvertimeAllowed === true ? "Yes" : "No"}
              </label>
            </div>
        </div>
      </div>
    </div>
  );
};
